import React from 'react'
import { CarouselArrowButtonProps } from '@interfaces/Drivetypes'

const CarouselArrowButton = ({
  direction,
  onClick,
  className,
  iconClassName,
  ariaLabel,
  size,
}: CarouselArrowButtonProps) => {
  const isLeft = direction === 'left'
  const width = size === 'desktop' ? 25 : 15
  const height = size === 'desktop' ? 25 : 15

  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
      aria-label={ariaLabel}
      style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
      <svg
        className={iconClassName}
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 25 25"
        fill="none">
        <path
          d={
            isLeft ? 'M9.3749 17.7096L4.16667 12.5013L9.375 7.29297' : 'M15.6251 17.7096L20.8333 12.5013L15.625 7.29297'
          }
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d={isLeft ? 'M20.832 12.5H4.16537' : 'M4.16797 12.5H20.8346'}
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}

export default CarouselArrowButton
